import Direction3D from './Direction3D';
import Point3D from './Point3D';

/**
 * A representation of the position and orientation of a 3D coordinate system relative to a reference 3D coordinate
 * system. It is isometric, meaning that distances, angles, etc. are preserved when mapping between spaces; there is no
 * scaling/skewing.
 */
export default class Isometry {
  /** The direction in reference coordinates of the positive direction of the embedded system's x-axis. */
  public readonly xAxis: Direction3D;

  /** The direction in reference coordinates of the positive direction of the embedded system's y-axis. */
  public readonly yAxis: Direction3D;

  /** The direction in reference coordinates of the positive direction of the embedded system's z-axis. */
  public readonly zAxis: Direction3D;

  /** The position in reference coordinates of the embedded system's origin. */
  public readonly origin: Point3D;

  constructor(xAxis: Direction3D, yAxis: Direction3D, zAxis: Direction3D, origin: Point3D) {
    this.xAxis = xAxis;
    this.yAxis = yAxis;
    this.zAxis = zAxis;
    this.origin = origin;
  }
}
